var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"align":"center"}},[_c('v-row',{staticClass:"flex-column align-center"},[_c('span',[_vm._v(" "+_vm._s(_vm.text)+" "+_vm._s((_vm.success) ? 'успешно' : 'неуспешно')+" "),_c('v-icon',{attrs:{"color":(_vm.success) ? 'green' : 'red'}},[_vm._v("mdi-check")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }